export enum CALENDAR_OPTIONS {
  APPLE = 'apple',
  GOOGLE = 'google',
  OUTLOOK = 'outlook',
  OTHER = 'other',
}
